import React from "react";
import Modal from "../Modal/Modal";
import { EmailLogsType } from "../../Pages/Admin/EmailLogs/EmailLogs";
import styles from "./EmailLogModal.module.scss";
import { DateTime } from "luxon";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedRowData: EmailLogsType | null;
}

function EmailLogModal(props: Props) {
  const { isOpen, setIsOpen, selectedRowData } = props;

  const valueFormatter = (value: any) => {
    if (value instanceof Date) {
      return DateTime.fromJSDate(value).toFormat("MM/dd/yyyy hh:mm a");
    }
    if (typeof value === "boolean") {
      return value ? "True" : "False";
    }
    return value;
  };
  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className={styles.mainContainer}>
        <div className={styles.headingContainer}>
          <h1 className={styles.heading}>Email Log</h1>
        </div>
        <div className={styles.contentContainer}>
          {selectedRowData &&
            Object.keys(selectedRowData as EmailLogsType).map((key, i) => {
              const typedKey = key as keyof EmailLogsType;
              if (typedKey === "awsEmailResponse") {
                const prettyJson = JSON.stringify(
                  selectedRowData?.[typedKey],
                  null,
                  2
                );
                return (
                  <div className={styles.contentItem} key={i}>
                    <h2 className={styles.contentItemHeading}>{typedKey}</h2>
                    <pre className={styles.contentItemValue}>{prettyJson}</pre>
                  </div>
                );
              }
              return (
                <div className={styles.contentItem} key={i}>
                  <h2 className={styles.contentItemHeading}>{typedKey}</h2>
                  <p className={styles.contentItemValue}>
                    {valueFormatter(selectedRowData?.[typedKey])}
                  </p>
                </div>
              );
            })}
        </div>
      </div>
    </Modal>
  );
}

export default EmailLogModal;
